import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHuurwoning = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M5 18.94 14 13l9 5.94V34H5z"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      d="M35 8H19v22h16zM14 26H9v8h5z"
    />
    <path
      fill="#00215B"
      d="M22 12.5v-1h10v1zm0 4v-1h10v1zm5.5 7.5h1v2.5H22v-1h5.5zm-5.777-2.584-9-6 .554-.832 9 6z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHuurwoning);

export default ForwardRef;
